<app-window [title]="title">
    <form role="form" id="detailForm">
        <div class="row">
            <div class="col-sm-2 text-center">
                <i class="animation__shake fa-cash-register fas pt-5 fa-5x text-gray"></i>
            </div>
            <div class="col-sm-10">
                     
                <div class="row">
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Data</label>
                            <div class="input-group" >
                                <input class="form-control " type="date"  name="date"  [(ngModel)]="record.date"  />
                            </div>
                        </div>
                    </div>

                    
                    
                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Operatore</label>
                            <select *ngIf="checkPermissions('showUsers')" class="form-control" [(ngModel)]="record.id_user" name="id_user" #id_user="ngModel" required (ngModelChange)="getCashflowByIdUser();setCash()">
                                <option *ngFor="let t of users" [ngValue]="t.id">{{t.username}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-sm-3">
                        <div class="form-group">
                            <label>Cassa</label>
                            <select class="form-control" [(ngModel)]="record.id_cash" name="id_cash" #id_cash="ngModel" required>
                                <option *ngFor="let c of cashes" [ngValue]="c.id">{{c.name}}</option>
                            </select>
                        </div>
                    </div>                    
                    <div class="col-sm-3">
                        <div class="form-group ">
                            <label>Sede</label>                     
                            <select class="form-control " name="created_from" #created_from="ngModel" [(ngModel)]="record.created_from">
                                <option  value="0">Tutte le sedi</option>
                                <option *ngFor="let s of shops" [ngValue]="s.id">{{s.name}}</option>
                            </select>                               
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Calcola</label><br/>
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary" (click)="getCashflowByIdUser()">Incasso giornaliero</button>
                                <button type="button" class="btn btn-secondary" (click)="getBalance()">Versamento saldo attuale</button>
                            </div>
                        </div>
                    </div>
                    
                    <!--
                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>Calcolato</label>
                            <div class="input-group ">
                                <div class="input-group-prepend ">
                                    <span class="input-group-text">&euro;</span>
                                </div>
                                <span class="form-control bg-light" >{{record.amount}}</span>
                            </div>
                        </div>
                    </div>
                    -->
                    <div class="col-sm-3">
                        <div class="form-group ">
                            <label>
                                <span *ngIf="record.paid>=0">Incasso</span>
                                <span *ngIf="record.paid<0">Versamento</span>
                            </label>
                            <div class="input-group" >
                                <div class="input-group-prepend ">
                                    <span class="input-group-text">&euro;</span>
                                </div>
                                <input type="number" class="form-control " [class.text-danger]="record.paid<0" min="0" step="0.01" name="paid" placeholder="..." [(ngModel)]="record.paid " >
                            </div>
                        </div>
                    </div>
                                   
                
                    <div class="col-sm-9">
                        <div class="form-group">
                            <label>Descrizione</label>
                            <input type="text" class="form-control " placeholder="..." name="description" [(ngModel)]="record.description">
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </form>
    <app-toolbarmodel [model]="this"></app-toolbarmodel>
</app-window>